import {
    AutoPayment,
    AutoPaymentDescription,
} from 'billing/components/AutoPayment/AutoPayment';
import { getCreditCardSelectors } from 'billing/modules/CreditCardModule/CreditCardModule';
import classNames from 'classnames';
import React from 'react';
import { ReduxHooks } from 'utils/hooks/ReduxHooks';

import { CurrentUserSelectors } from 'reactApp/modules/CurrentUserModule';
import { InfoMessage } from 'reactComponents/InfoMessage/InfoMessage';

import styles from './AutoPaymentTab.css';
import { Mastercard } from './Mastercard';
import { PciDss } from './PciDss';
import { Visa } from './Visa';

type Props = {
    isShown: boolean;
    onClose(): void;
};
export function AutoPaymentTab({ isShown, onClose }: Props) {
    const pid = ReduxHooks.useSelector(CurrentUserSelectors.getPid);
    const card = ReduxHooks.useSelector(getCreditCardSelectors(pid).getData);

    return (
        <div
            className={classNames(styles.root, {
                [styles.hidden]: !isShown,
            })}
        >
            {card ? (
                <AutoPayment isActiveDefault onClose={onClose} />
            ) : (
                <>
                    <InfoMessage className={styles.infoMessage} withoutIcon>
                        Чтобы подключить автопополнение, привяжите банковскую
                        карту для оплаты услуг.
                    </InfoMessage>
                    <AutoPaymentDescription />
                </>
            )}
            <div className={styles.footer}>
                <div>
                    <div className={styles.secureProtocol}>HTTPS / SSL</div>
                    <div className={styles.secureConnection}>
                        Защищённое соединение.
                    </div>
                </div>
                <div className={styles.services}>
                    <PciDss />
                    <Mastercard />
                    <Visa />
                </div>
            </div>
        </div>
    );
}
